// extracted by mini-css-extract-plugin
export default {"content":"index_content__ZHuK7"};